import React from 'react'
import { Box, Typography, Divider, Stack } from '@mui/material'
import Title from 'Components/Title'
import config from '../../../static/Fim'
import { ButtonBack } from 'Components/Back'
//import { useUser } from 'services/StateContext'
import { capitalizeWords, inviteInCalendar } from 'services/utils'


import { ClinicaEndereco, PdfDownload } from 'Components/PdfViewer'
import { usePatient } from 'Components/usePatientContext'

//import SaveAltIcon from '@mui/icons-material/SaveAlt'
//import EventAvailableIcon from '@mui/icons-material/EventAvailable'
//import { parse } from 'date-fns'
//import ReactDOMServer from 'react-dom/server'

//import { PDFViewer } from '@react-pdf/renderer'

// const style = { 
//     p: 2,
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '5px',
//     backgroundColor: '#fff',
    
// }



const Agendado = () => {

    const { handleSchedulePatient } = usePatient()

    const agendamento = handleSchedulePatient()

    const business_name            = process.env.REACT_APP_BUSINESS_NAME
    const business_address         = process.env.REACT_APP_BUSINESS_ADDRESS
    const business_city_state      = process.env.REACT_APP_BUSINESS_CITY_STATE
    const business_phone_number    = process.env.REACT_APP_BUSINESS_PHONE_NUMBER
    const business_whatsapp_number = process.env.REACT_APP_BUSINESS_WHATSAPP_NUMBER
    
    const nome = agendamento?.nomePessoa ?? agendamento?.nomePaciente

    const importante  = JSON.parse(process.env.REACT_APP_IMPORTANTE)
    const observacoes = JSON.parse(process.env.REACT_APP_OBSERVACOES)
    const site_url    = "https://" + process.env.REACT_APP_SITE_URL

    // return <PDFViewer
    //     showToolbar={false}
    //     style={{
    //       width: '100%',
    //       height: '100vh',
    //     }}
    // >
    //     <PdfViewer user={user} />

    // </PDFViewer>

    const addToSchedule = (user) => {
    
        const endereco = ClinicaEndereco
            .filter(address => address.adddress !== undefined)
            .map(adr => adr.text)
            .join(', ')

        const location      =  endereco
        
        const especialidade = capitalizeWords(user?.descricaoEspecialidade)   
        const profissional  = capitalizeWords(user?.nomeProfissional) 
        //const horario       = user?.horarioAgenda.split(':') 
        const agendaData    = user?.dataAgenda.split('/') 
        
        const dia = agendaData[0]
        const mes = agendaData[1]
        const ano = agendaData[2]

        const data_hora = `${ano}-${mes}-${dia} ${user?.horarioAgenda}`  
        
        
        
        const state = {
            title: `${business_name} - Consulta ${especialidade}`,
            description: `Agendamento de consulta com médico(a) ${profissional} na especialidade de ${especialidade}`,
            location,
            startDate: new Date(data_hora),
            //endDate: new Date(),
        }

        inviteInCalendar(state)
    }

    return (<Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{justifyContent: 'center'}}
    >   
        <Title margin={'0'} hidden title={config.title} sx={{
            "&.MuiTypography-root": { 
                fontSize: {
                    xs: '1.2rem !important' 
                }, 
                color: process.env.REACT_APP_BUTTON_STYLE_BG,
                textTransform: 'uppercase'} 
            }
        } />
        <Divider sx={{my: '5px'}}/>
        <Stack position={'relative'} >
            <Stack direction="column" className={'dados_paciente/'}>
                <Typography 
                    variant={'p'} 
                    component={'p'}
                >Nome: {capitalizeWords(nome) || ''}</Typography>
                
                <Typography 
                    variant={'p'} 
                    component={'p'} 
                >CPF: {agendamento?.cpfPaciente || ''}</Typography>
                
                <Typography 
                    variant={'p'} 
                    component={'p'} 
                    data-convenio={agendamento?.descricaoConvenio?.toLowerCase()}
                >Convênio: {capitalizeWords(agendamento?.descricaoConvenio) || ''}</Typography>
                
                <Typography 
                    variant={'p'} 
                    component={'p'} 
                    data-especialidade={agendamento?.descricaoEspecialidade?.toLowerCase()}
                >Especialidade: {capitalizeWords(agendamento?.descricaoEspecialidade) || ''}</Typography>
                
                <Typography 
                    variant={'p'} 
                    component={'p'}  
                    data-medico={agendamento?.nomeProfissional?.toLowerCase()}
                >Médico(a): {capitalizeWords(agendamento?.nomeProfissional) || ''}</Typography>
                
                <Typography 
                    variant={'p'} 
                    component={'p'} 
                    data-data_agenda={agendamento?.dataAgenda}
                    data-horario_agenda={agendamento?.horarioAgenda}
                >Data/Hora: {agendamento?.dataAgenda} - {agendamento?.horarioAgenda}h</Typography>
                
                <Divider sx={{my: '5px'}}/>
                <Typography variant='p'>Endereço da {business_name}: </Typography>
                <Typography variant='p'>{business_address}</Typography>
                <Typography variant='p'>{business_city_state}</Typography>
                <Typography variant='p'>Telefone: {business_phone_number}</Typography>
                <Typography variant='p'>WhatsApp: {business_whatsapp_number}</Typography>
                
            </Stack>  
            <Divider sx={{my: '5px'}}/>
            <Box >
                <Box >
                    {observacoes.map( item => <Typography key={item} sx={{fontStyle: 'bold'}} variant="p" component="div" >{item}</Typography>)}
                </Box>
                <Divider sx={{my: '5px'}}/>
                <Typography component={'div'} variant={'body1'} color="error.main" fontSize={'12px'}>
                    {importante.map(item => <div key={item}>{item}</div>)}
                </Typography>
            </Box>
            
        </Stack>
        <Divider sx={{mt: '5px', mb: 2}}/>
        <Stack direction={{md: "row", sm: "column", xs: "column-reverse" }} spacing={2} sx={{marginBottom: {sm: 1, xs: 1} }} >
            <ButtonBack variant={'contained'} href={site_url}>Voltar ao site</ButtonBack>
            <ButtonBack 
                sx={{maxWidth: {md: '250px'}}} 
                variant={'contained'} 
                children={'Inserir agenda google'}
                onClick={() => addToSchedule(agendamento)}   
            />
            <PdfDownload style={{textDecoration: 'none'}} user={agendamento}>
                <ButtonBack 
                    sx={{minWidth: '250px', maxWidth: {md: '250px'}}} 
                    variant={'contained'} 
                    children={'Gerar PDF'}  
                />
            </PdfDownload>
            
        </Stack>
        
    </Box>)
}

export default Agendado